import { FC } from 'react';
import styled from 'styled-components';
import { GenericContainerCard, SideSpace } from '../UtilitiesMatchMobile/GenericCssComponentMatchMobile';
import CenterInfoFightRendering from '../UtilitiesMatchMobile/GenericRendering/CenterInfoFightRendering';
import RenderWrestlerWhenFourInSpace from './RenderWrestlerBySpaceAndNumber/RenderWrestlerWhenFourInSpace';
import RenderingMatchWithConditionExtended from '../UtilitiesMatchMobile/RenderingMatchWithConditionExtended';
import { Match, WrestlerInMatch } from '../../../../types';

export const WrapperSideSpace = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
`;

interface FourVsFourMatchRenderProps {
    matchInfo: Match;
    withWinner?: boolean;
    isExpanded?: boolean;
}

interface WrestlerWithTeam extends WrestlerInMatch {
    team?: number;
}

const FourVsFourMatchRender: FC<FourVsFourMatchRenderProps> = ({ matchInfo, withWinner = false, isExpanded = false }) => {
    // wrestlers1 sono i matchinfo.wrestlers con team 1
    // wrestlers2 sono i matchinfo.wrestlers con team 2
    const wrestlers1 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 1);
    const wrestlers2 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 2);

    function renderGenericContainerCard() {
        return (
            <GenericContainerCard className='four-vs-four-match-render'
            height={isExpanded ? '80%' : '100%'}
            >
                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        {wrestlers1.map((wrestler, index) => (
                            <RenderWrestlerWhenFourInSpace
                                wrestler={wrestler}
                                side='left'
                                key={index}
                                withWinner={withWinner}
                            />
                        ))}
                    </WrapperSideSpace>

                </SideSpace>
                <CenterInfoFightRendering matchInfo={matchInfo} typeMatch='Four-vs-Four' />
                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        {wrestlers2.map((wrestler, index) => (
                            <RenderWrestlerWhenFourInSpace
                                wrestler={wrestler}
                                side='right'
                                key={index}
                                withWinner={withWinner}
                            />
                        ))}
                    </WrapperSideSpace>

                </SideSpace>
            </GenericContainerCard>
        )
    }

    return (
        RenderingMatchWithConditionExtended({ renderGenericContainerCard, isExpanded, matchInfo })
    )
}

export default FourVsFourMatchRender;
